import React from "react";
import ProductsSection from "../ProductsSection/ProductsSection";
import Banner from "../Banner/Banner";
import ContactSection from "../ContactSection/ContactSection";



const Home = () => {
  return (
    <div>
      <Banner></Banner>
   
      <ContactSection></ContactSection>
      <ProductsSection></ProductsSection>
    </div>
  );
};

export default Home;
